import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const RegistrationFilterDtoServiceConfig = {
  name: "RegistrationFilterDto",
  annotations: []
} as ServiceConfig;